module.exports = __webpack_public_path__ + "img/ew-icon_approved.49c0e3b8.svg";